










































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
// Components
import PatientAcquisitionConditions from '@/components/patients/acquisition/PatientAcquisitionConditions.vue';
import ChartRawGaugeSections from '@/components/charts/walking/ChartRawGaugeSections.vue';

@Component({
  components: {
    PatientAcquisitionConditions,
    ChartRawGaugeSections,
  },
})
export default class ChartRunningPhaseGlobalBanner extends Vue {
  @Prop({ required: true }) acquisition!: TAcquisition['computed_data'];
  @Prop({ default: false }) acquisitionTreadmill!: boolean | number;
  @Prop({ default: null }) patient!: TEntity<TPatient>;

  get values() {
    return this.acquisition.computed_data;
  }
  get segments() {
    return this.values.segments;
  }

  get speed() {
    return (this.values.aggregates.left.running_speed.avg + this.values.aggregates.right.running_speed.avg) / 2;
  }
  get cadence() {
    return {
      name: 'cadence',
      value: this.values.aggregates.left.cadence.avg + this.values.aggregates.right.cadence.avg,
      ranges: {
        base: {
          min: 175,
          max: 185,
        },
        minRange: {
          min: 160,
          max: 175,
        },
        maxRange: {
          min: 185,
          max: 200,
        },
        extremMin: 145,
        extremMax: 215,
      },
      unit: `${this.$t('commons.units.steps').toString().slice(0, 1)}/min`,
      roundedValue: true,
    };
  }
  get analysisDuration() {
    const length = this.segments.length - 1;
    let startTime = (this.segments[length].left.header.start_time + this.segments[length].right.header.start_time) / 2;
    let duration = (this.segments[length].left.header.duration + this.segments[length].right.header.duration) / 2;
    return (this.$moment as any)
      .duration({
        seconds: (startTime + duration) / 32768,
      })
      .asMilliseconds();
  }
}
